import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

import { useOffCanvas } from '../../context/OffCanvasProvider';
import DonatePanel from '../panels//DonatePanel';
import Podcasts from './Podcasts';
import Contact from './Contact';
import Events from './Events';

import swal from 'sweetalert';

import feliz_image from '../../assets/frontend/images/feliz_1-1.png';
import podcast_icon from '../../assets/frontend/images/podcast_icon.png';

const resources = [
	{
		id: "listen-live",
		title: "Listen Live",
		type: "iframe",
		content: (
			<iframe
				title="Listen Live"
				width="450" height="316"
				frameborder="0"
				src="https://live365.com/embeds/v1/player/a96984?s=md&m=dark&c=mp3">
			</iframe>
		),
		link: "/radios/listen-live",
	},
	{
		id: "last-played",
		title: "Last Played Songs",
		type: "iframe",
		content: (
			<iframe
				title="Last Played Songs"
				width="450" height="511"
				frameborder="0"
				src="https://live365.com/embeds/v1/played/a96984?s=md&m=dark">
			</iframe>
		),
		link: "/radios/last-played",
	},
	{
		id: "sharing-rss",
		title: "Sharing Your Miraculous Life Podcast",
		type: "url",
		url: "https://anchor.fm/s/eff13fac/podcast/rss",
		link: "/podcasts/sharing-rss",
	},
	{
		id: "feliz-lltw-rss",
		title: "Feliz and Love Leads the Way Podcast",
		type: "url",
		url: "https://anchor.fm/s/10fcd1a1c/podcast/rss",
		link: "/podcasts/feliz-lltw-rss",
	},
	{
		id: "upcomming-events",
		title: "Upcoming Events",
		type: "component",
		component: <Events />,
		link: "/events",
	},
	{
		id: "contact-form",
		title: "Contact Form",
		type: "component",
		component: <Contact />,
		link: "/contact",
	},
];

const Home = () => {

	const [selected, setSelected] = useState(null);

	const { push: openCanvas } = useOffCanvas();  // load offcanvas functions

	const navHistory = useNavigate();

	function openDonate(e) {
		e.stopPropagation();

		openCanvas({
			component: DonatePanel,
			props: {
				track: null,
				tracklist: null,
			}
		});
	}

	const handleClick = (resource) => {
		//setSelected(resource);
		if (resource.id === "listen-live" || resource.id === "last-played") {
			navHistory("/radios/" + resource.id);
		} else if (resource.id === "sharing-rss" || resource.id === "feliz-lltw-rss") {
			navHistory("/podcasts/" + resource.id);
		} else if (resource.id === "upcomming-events") {
			navHistory("/events");
		} else if (resource.id === "contact-form") {
			navHistory("/contact");
		}
	};
	const handleComingSoon = (title) => {
		swal({
			title: "Coming Soon",
			text: title + " is coming soon. Stay tuned for updates!",
			icon: "info",
			button: "OK",
		});
	}
	const listenLive = resources.find(
		r => r.id === "listen-live"
	);
	const lastPlayed = resources.find(
		r => r.id === "last-played"
	);

	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-center mt-20l-10s">
						<div className="text-overlay-wrapper text-center">
							<div className="text-overlay-100per hide-for-small-only">
								{/* ROTATING TEXT ONLY */}
								<div className="horizontal-container position-align-bottom pb-20l-10s text-center">
									<span className="align-left pl-20">
										<Link to="/radios" className="button width-200px">Listen Live</Link>
									</span>
									<span className="align-right pr-20">
										<Link to="/podcasts" className="button width-200px">Latest Podcast</Link>
									</span>
								</div>
							</div>
							<img src={feliz_image} className="b5-000" alt="feliz image" width="100%" />
						</div>
						<div className="mt-20l-10s">
							<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per">
								<span className="font-libre-baskerville font-size-18l-16m font-weight-800">Love & Light</span>
								&nbsp;-&nbsp;
								You are welcome here. This is a place for peace, encouragement, purpose, love, and healing.
								<Link onClick={() => handleComingSoon('More About Love Leads The Way')}>... Read More</Link>
							</div>
						</div>
						<div className="horizontal-container pt-20 show-for-small-only">
							<span className="align-left">
								<Link to="/radios" className="button medium width-150px">Listen Live</Link>
							</span>
							<span className="align-right">
								<Link to="/podcasts" className="button medium width-150px">Latest Podcast</Link>
							</span>
						</div>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center b1-ccc p-20l-10s mt-30">
						<div className="font-libre-baskerville font-size-36l-30m-24s font-weight-800 pt-20">
							Welcome To
							<div className="pt-20 show-for-small-only"></div>
							<span className="hide-for-small-only">&nbsp;</span>
							Love Leads the Way
						</div>
						<div className="font-libre-baskerville font-size-24l-20m-18s font-weight-600 pt-30">God is Love, and Love Leads the Way.</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 text-center line-height-120per pt-30">
							A place for faith filled conversations, uplifting music, prayer, and encouragement.</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							The purpose of Love Leads the Way is to create a space where faith grows, hearts are encouraged, and people are reminded of God’s presence in every season of life. Through Christian radio and heartfelt podcast conversations, we share stories of faith, hope, healing, and the journey of following Jesus.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per pt-20">
							We believe every story matters, every prayer matters, and every step of faith matters. Whether you are seeking encouragement, growing in your walk with Christ, or simply looking for a reminder of God’s love, you are welcome here.
						</div>
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 text-center line-height-120per pt-20">
							Together, we are walking with Jesus one step at a time.
						</div>
						<div className="font-libre-baskerville font-size-24l-20m-18s font-weight-600 text-center line-height-120per pt-20">
							Love Leads the Way Radio and Podcast
						</div>
					</div>
					<div className="large-12 medium-12 small-12 cell text-center mt-30">
						<table>
							<tbody className="b1-ccc">
								{resources.map((resource, index) => (
									<tr key={index}>
										<td className="font-libre-baskerville font-size-18l-16m font-weight-400 text-left">{resource.title}</td>
										<td className="font-libre-baskerville font-size-18l-16m font-weight-400 text-right">
											<Link to={resource.link}>Open</Link>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					{/*selected && (
						<div className="large-12 medium-12 small-12 cell text-center pt-30">
							<div className="font-libre-baskerville font-size-24l-20m-18s font-weight-600 text-center pb-30">{selected.title}</div>

							{selected.type === "iframe" && selected.content}

							{selected.type === "url" && (
								<Link
									href={selected.url}
									target="_blank"
									rel="noopener noreferrer"
								>
									{selected.url}
								</Link>
							)}

							{selected.type === "component" && selected.component}
						</div>
					)*/}
				</div>
			</div>

		</div>

	);
}

export default Home;